import { render, staticRenderFns } from "./qiujing.vue?vue&type=template&id=1d6cbe87&scoped=true"
import script from "./qiujing.vue?vue&type=script&lang=js"
export * from "./qiujing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6cbe87",
  null
  
)

export default component.exports